import { useDispatch, useSelector } from "react-redux";
import PurchaseDetail from "./PurchaseDetail"
import { saveBulkOrderFleetPurchaseDetail, setBulkOrderFleetHeader, setBulkOrderHeader, setSaveBulkFleetPurchaseDetail } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import { useEffect, useState } from "react";
import userProfileSelectors from '../../../../../redux/UserProfile/selectors'
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";

const PurchaseDetailContainer = (props?: any) => {
    const dispatch = useDispatch();

    const {
        purchaseOrderStepperData,
        setIsButtondisable,
        activeStepper,
        id
    } = props;
    
    const [purchaseDetailsPayload, setPurchaseDetailsPayload] = useState<any>([]);
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
      });

    const { 
        bulkOrderHeaderDetails,
        bulkOrderFleetDetails, 
        userDetails,
        isBulkFleetPurchaseDetailSaved
     }: any = useSelector((state: any) => ({
        bulkOrderHeaderDetails: state.PurchaseBulkOrderReducer.bulkOrderHeaderDetails,
        bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
        userDetails: userProfileSelectors.getUserDetails(state),
        isBulkFleetPurchaseDetailSaved: state.PurchaseBulkOrderReducer.isBulkFleetPurchaseDetailSaved
    }))

    useEffect(()=>{
        if(purchaseOrderStepperData?.purchaseDetails?.items?.length > 0){
            let isDisable = false;
            purchaseOrderStepperData?.purchaseDetails?.items?.map((childItem:any) => {
                if(!childItem?.assetNumber || childItem?.assetNumberError?.length > 0 || childItem?.barcodeNoError){
                    isDisable = true
                }
            })
            setIsButtondisable(isDisable);
        }
    },[purchaseOrderStepperData?.purchaseDetails])

    useEffect(()=>{
        if(purchaseOrderStepperData){
            const payload = {
                "orderDetailId": purchaseOrderStepperData?.orderDetailId,
                "purchaseType": purchaseOrderStepperData?.purchaseDetails?.purchaseType,
                "description": purchaseOrderStepperData?.purchaseDetails?.description,
                "pricePerUnit" : purchaseOrderStepperData?.pricePerUnit,
                "assetModelId" : purchaseOrderStepperData?.purchaseDetails?.assetModelId,
                "createUniquePo": purchaseOrderStepperData?.purchaseDetails?.createUniquePo,
                "isLicensedTitled": purchaseOrderStepperData?.purchaseDetails?.isLicensedTitled,
                "savedBy": userDetails?.emailId
            }
        setPurchaseDetailsPayload(payload);
    }
    },[purchaseOrderStepperData])

    const updateFleetHeader = (name:any, value:any, itemDetails? : any) => {
        const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        bulkOrderFleetDetailsTemp?.map((item?: any) => {
            if (item?.orderDetailId == purchaseOrderStepperData.orderDetailId) {
                if(name == "description"){
                    item.purchaseDetails = {
                        ...item.purchaseDetails,
                        [name]: value,
                        pricePerUnit : itemDetails.price,
                        assetModelId : itemDetails.value
                    }
                }
                else{
                    item.purchaseDetails = {
                        ...item.purchaseDetails,
                        [name]: value
                    }
                }
            }
        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    }

    const handleOnChange = (name:any, value:any, item?:any) => {
        const payload:any = purchaseDetailsPayload ? JSON.parse(JSON.stringify(purchaseDetailsPayload)) : []
        let payloadTemp : any = {} 
        if(name == 'description'){
            payloadTemp = {
               ...payload,
               pricePerUnit : item?.price,
               assetModelId : item?.value,
               [name] : value
            }
        }
        else {
            payloadTemp = {
                ...payload,
                [name]: value
            }
        }
        dispatch(saveBulkOrderFleetPurchaseDetail(payloadTemp))
        updateFleetHeader(name, value,item)
    }

    useEffect(() => {
        if (isBulkFleetPurchaseDetailSaved?.isSaved && isBulkFleetPurchaseDetailSaved != null) {
            const bulkOrderHeaderDetailsTemp: any = bulkOrderHeaderDetails ? JSON.parse(JSON.stringify(bulkOrderHeaderDetails)) : []
            dispatch(setBulkOrderHeader({...bulkOrderHeaderDetailsTemp, grandTotal: isBulkFleetPurchaseDetailSaved.total}))
            const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
            bulkOrderFleetDetailsTemp?.map((item?: any) => {
                if (item?.orderDetailId == isBulkFleetPurchaseDetailSaved?.orderDetailId) {
                    item.equipmentSpecification = item?.purchaseDetails?.description
                    item.pricePerUnit = item?.purchaseDetails?.pricePerUnit ?? item.pricePerUnit
                }
            })
            dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        } else if (!isBulkFleetPurchaseDetailSaved?.isSaved && isBulkFleetPurchaseDetailSaved != null) {
            let decriptionTxt = (
                <>
                    <p>Error Occured while saving the value.</p>
                </>
            );
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "OK",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                }
            });
        }
        dispatch(setSaveBulkFleetPurchaseDetail(null))
    }, [isBulkFleetPurchaseDetailSaved])

    const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    };

    return(
        <PurchaseDetail 
            purchaseOrderStepperData = {purchaseOrderStepperData}
            handleOnChange={handleOnChange}
            setIsButtondisable={setIsButtondisable}
            activeStepper = {activeStepper}
            id = {id}
            Popupcontent = {Popupcontent}
            hideDialog = {hideDialog}
        />
    )
}

export default PurchaseDetailContainer